import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/utilities';

class CardProductPrice extends HTMLElement {
  #servingData = {};
  #closestSection = null;

  connectedCallback() {
    this.#servingData = this.#parseServingData();

    this.#closestSection = this.closest('.shopify-section');
    this.#closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#closestSection = null;
  }

  get #productId() {
    return this.getAttribute('data-product-id');
  }

  get #priceElement() {
    return this.querySelector('[data-ref="price"]');
  }

  get #compareAtPriceElement() {
    return this.querySelector('[data-ref="compareAtPrice"]');
  }

  get #servingPriceElement() {
    return this.querySelector('[data-ref="servingPrice"]');
  }

  #parseServingData() {
    try {
      const json = this.querySelector('script[data-ref="servingData"]')?.textContent;
      return json ? JSON.parse(json) : {};
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  #onVariantUpdate = (event) => {
    const target = event.target;
    if (target instanceof HTMLElement && target.getAttribute('data-product-id') !== this.#productId) {
      return;
    }

    const variant = event.detail?.variant;
    if (!variant) return;

    this.#updatePrice(variant);
  };

  #updatePrice(variant) {
    const hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (this.#priceElement) {
      this.#priceElement.textContent = formatMoney(variant.price, Theme.settings.currency_format);
    }

    if (this.#compareAtPriceElement) {
      this.#compareAtPriceElement.textContent = hasSale ? formatMoney(variant.compare_at_price, Theme.settings.currency_format) : '';
      this.#compareAtPriceElement.hidden = !hasSale;
    }

    const servingData = this.#servingData[variant.id];
    if (this.#servingPriceElement) {
      if (servingData?.serving_price) {
        const labelTemplate = this.#servingPriceElement.dataset.label ?? '%%%PRICE%%%';
        this.#servingPriceElement.textContent = `(${labelTemplate.replace('%%%PRICE%%%', servingData.serving_price)})`;
        this.#servingPriceElement.hidden = false;
      } else {
        this.#servingPriceElement.textContent = '';
        this.#servingPriceElement.hidden = true;
      }
    }
  }
}

if (!customElements.get('card-product-price')) {
  customElements.define('card-product-price', CardProductPrice);
}
